import { render, staticRenderFns } from "./MainPartner.vue?vue&type=template&id=596a2edc&"
import script from "./MainPartner.vue?vue&type=script&lang=js&"
export * from "./MainPartner.vue?vue&type=script&lang=js&"
import style0 from "./MainPartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports